<template>
  <cargo-advance-select
    v-if="visible"
    :disabled="disabled"
    :select-type="selectTypeNames.basic_data_Department"
    filterable
    :default-value="departmentId||''"
    :method-params="methodParams"
    :placeholder="placeholder"
    @parentCallBack="p=>{$emit('change',p)}"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getUserInfo } from '@/utils/auth'

export default {
  name: 'CargoDepartmentSelectByOfficeId',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    officeId: { type: Number, default: 0 },
    departmentId: { type: Number, default: 0 },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      selectTypeNames: TYPE_NAMES,
      officeList: null
    }
  },
  computed: {
    methodParams() {
      const office = this.officeList.filter(
        (item) => item.officeId === this.officeId
      )
      console.log('office', office)
      if (office.length === 1) {
        return { officeUuid: office[0].uuid }
      }
      return { officeUuid: '' }
    }
  },
  created() {
    this.officeList = getUserInfo().currentUserOfficeList
    this.visible = true
  }
}
</script>

<style>
</style>
